import {buildFormServerCall} from '../../services/formService';
import {getStateXml} from '../../../_shared/GWTBridge/invoke/server';
import {addFormOperation} from '../../../_shared/GWTBridge/invoke/netForm';
import {Keys} from '../consts/keys';
import {Form} from '../stores/Form';

export function formQuery(session: string, params?) {
    const methodName = 'FormQuery';
    const reason = 'Form Query';

    const statexml = getStateXml(session);
    // We use Object.assign method instead of spread operator because of unexpected behavior of spread in safari (BUG: #9029)
    const parameters = Object.assign(
        {
            statexml: [statexml],
            field: ['0'],
            line: ['2'],
            alen: ['2'],
            wkey: ['7'],
            first: ['1'],
            last: ['1'],
            gotofld: ['0'],
            gotoline: ['0']
        },
        params
    );

    return buildFormServerCall(methodName, parameters, reason, false);
}

export function startQueryOperation(form: Form) {
    addFormOperation({
        ...form.formState,
        key: Keys.Tquery,
        currentFieldValue: ''
    });
}

export function formStart(formName: string) {
    const methodName = 'FormStartEx';
    const reason = 'Form Start';

    const parameters = {
        form: [formName],
        scrwidth: ['-1'],
        link: [''],
        linkid: [''],
        zoomcolumn: ['0'],
        zoomname: [''],
        debug: ['false'],
        sendtitles: ['false'],
        zoomvalue: [''],
        popup: ['false']
    };

    return buildFormServerCall(methodName, parameters, reason, false);
}

export function sortForm(currentForm, isAsc: boolean, sortColumn: string) {
    addFormOperation({
        ...currentForm.formState,
        key: Keys.None,
        isActive: '1'
    });

    const methodName = 'FormSort';
    const reason = 'Form Sort';

    const statexml = getStateXml(currentForm.session);
    const parameters = {
        statexml: [statexml],
        asc: [isAsc ? 'true' : 'false'],
        byfld: [sortColumn.toString()]
    };

    return buildFormServerCall(methodName, parameters, reason, false);
}

export function getSumTotal(currentForm) {
    const {row, columnName} = currentForm.currentCell;
    const value = (currentForm.rows.length && currentForm.rows[row]?.[columnName]) || '';

    addFormOperation({
        ...currentForm.formState,
        currentFieldValue: value,
        key: Keys.None
    });

    const methodName = 'FormKey';
    const reason = 'Sum Total';

    const statexml = getStateXml(currentForm.session);
    const parameters = {
        statexml: [statexml],
        key: [(-Keys.Total).toString()]
    };

    return buildFormServerCall(methodName, parameters, reason, false);
}

export function getLabels(form, isProcessServerAnswerGWT) {
    const methodName = 'FormKey';
    const reason = 'Send Labels';

    const statexml = getStateXml(form.session);
    const parameters = {statexml: [statexml], key: [-Keys.SEND_LABELS + '']};

    return buildFormServerCall(methodName, parameters, reason, isProcessServerAnswerGWT);
}

export function generateLabels(form: Form, label: string, lines: string, clean: string) {
    const methodName = 'FormGenerateLabels';
    const reason = 'Generate Labels';

    const statexml = getStateXml(form.session);

    const parameters = {
        statexml: [statexml],
        label: [label],
        lines: [lines],
        clean: [clean],
        print: ['true']
    };

    return buildFormServerCall(methodName, parameters, reason, false);
}

export function saveActiveRow() {
    const methodName = 'FormKey';
    const reason = 'Save row';
    const statexml = getStateXml();
    const parameters = {statexml: [statexml], key: [(-Keys.SaveRow).toString()]};
    return buildFormServerCall(methodName, parameters, reason, true);
}

export function getRowKeysValues() {
    const methodName = 'RowKeysValues';
    const reason = 'get row keys values';
    const statexml = getStateXml();
    const parameters = {statexml: [statexml]};
    return buildFormServerCall(methodName, parameters, reason, false);
}

export function updateAutomationRules() {
    const methodName = 'FormActiveSave';
    const reason = 'Update Automation Rules';
    const statexml = getStateXml();
    const parameters = {statexml: [statexml], alert: ['-1'], isActive: ['Y']};
    return buildFormServerCall(methodName, parameters, reason, false);
}

export function reloadLegacyForm(mode: string) {
    const methodName = 'FormDesignSet';
    const reason = 'Reload design';
    const stateXml = getStateXml();
    const parameters = {statexml: [stateXml], mode: [mode], xml: [stateXml]};
    return buildFormServerCall(methodName, parameters, reason, true);
}
